import { useEffect, useState } from "react";
import { Services } from "../../../data/services/services";
import { Link, useNavigate } from "react-router-dom";
import { BiSolidBriefcaseAlt2 } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import { fetchServices } from "../../../redux/actions/serviceActions";
import { toast } from "react-toastify";

function formatNumber(value) {
  const num = Number(value);
  return num % 1 === 0 ? num : num.toFixed(2);
}

export default function SectionSix() {
  const navigate = useNavigate();
  const storedUser = localStorage.getItem("customeruser");
  const [currentSlide, setCurrentSlide] = useState(0);
  const [itemsPerSlide, setItemsPerSlide] = useState(1); 
  const [loading, setLoading] = useState(false);

  const { service } = useSelector(
    (state) => state.serviceState
  );

  const dispatch=useDispatch();

  useEffect(() => {
  const fetchData = async () => {
    try {
      setLoading(true);
      if(service.length===0){
         dispatch(fetchServices()); 
      }      
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, [dispatch,service.length]);

  const updateItemsPerSlide = () => {
    if (window.innerWidth >= 1280) {
      setItemsPerSlide(8); 
    } else if (window.innerWidth >= 768) {
      setItemsPerSlide(4); 
    } else {
      setItemsPerSlide(1); 
    }
  };

  useEffect(() => {
    updateItemsPerSlide();
    window.addEventListener("resize", updateItemsPerSlide);
    return () => window.removeEventListener("resize", updateItemsPerSlide);
  }, []);

  const totalSlides = Math.ceil(service.length / itemsPerSlide);

  useEffect(() => {
    if (itemsPerSlide < service.length) {
      const interval = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % totalSlides);
      }, 10000); 
      return () => clearInterval(interval);
    }
  }, [itemsPerSlide,service.length, totalSlides]);

  const handleBookService = (id,title) => {
    if (storedUser) {
      navigate("/bookservice", { state: { id: id, title: title } });
    } else {
      toast.warning("Please login to continue");
      setTimeout(() => navigate("/login"), 1000);
      return;
    }
  };

  const startIndex = currentSlide * itemsPerSlide;
  const endIndex = startIndex + itemsPerSlide;
  const visibleServices =
    endIndex <= service.length
      ? service.slice(startIndex, endIndex)
      : [...service.slice(startIndex), ...service.slice(0, endIndex - service.length)];
  
  const activeDot = currentSlide;

  if (loading) {
    return <p className="text-center mt-10">Loading services...</p>;
  }

  return (
    <div className="w-full max-w-7xl mx-auto p-4">
      <div className="flex justify-center">
        <p className="text-xl md:text-2xl xl:text-3xl font-semibold mb-5">Our Services</p>
      </div>

     
      <div
        className={`grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 transition-all duration-500
        ${visibleServices.length <= 4 ? "grid-rows-1" : "grid-rows-2 md:grid-rows-2 xl:grid-rows-2"}`}
      >
        {visibleServices.map((data, index) => (
          <div
            key={index}
            className="rounded-lg shadow bg-gray-100 flex flex-col justify-between pt-2 gap-5"
          >
            <Link to={`/servicedetail/${data.id}`}>
              <div className="relative">
                <img
                  src={data.images?.[0].image}
                  alt={data.serviceName}
                  className="w-full h-48 object-contain pt-5"
                />
                <div className="absolute top-2 left-2 bg-green-600 text-white text-xs font-semibold px-2 py-1 rounded-full">
                  {formatNumber(data.discountPercent)}% OFF
                </div>
              </div>
            </Link>
              <div className="flex flex-col bg-gradient-to-b from-[#E96364] to-[#FEB5B6] py-2 px-3 rounded-lg text-white">
                <Link to={`/servicedetail/${data.id}`}>
                <div className="flex ">
                  <h2 className="text-base xl:text-lg font-semibold">
                    {data.serviceName}
                  </h2>
                </div>
                </Link>
                <div className="flex flex-row justify-between space-x-2">
                  <Link to={`/servicedetail/${data.id}`}>
                  <div className="flex flex-row space-x-3 text-sm md:text-base justify-between">
                    <p>Starts from ₹{formatNumber(data.price)}</p>
                    <p className="line-through text-gray-200">
                      ₹{formatNumber(data.oldPrice)}
                    </p>
                  </div>
                  </Link>
                  <div className="flex justify-end items-end bg-white rounded-full p-2">
                    <button
                      onClick={() => handleBookService(data.id, data.serviceName)}
                      className="text-xl text-[#A63F40] hover:text-[#7b2f30] transition"
                    >
                      <BiSolidBriefcaseAlt2 />
                    </button>
                  </div>
                </div>
                
              </div>
            {/* </Link> */}
          </div>
        ))}
      </div>

     {itemsPerSlide < Services.length && (
         <div className="flex justify-center mt-4 xl:mt-6 space-x-2">
         {(() => {
           const isMobile = window.innerWidth < 768;
     
           const dotsToRender = [];
     
           if (isMobile) {
             const start = Math.max(0, activeDot - 1);
             const end = Math.min(totalSlides - 1, activeDot + 1);
     
             for (let i = start; i <= end; i++) {
               dotsToRender.push(
                 <span
                   key={i}
                   className={`h-2 w-2 rounded-full transition-all duration-300 ${
                     i === activeDot ? "bg-blue-600 scale-110" : "bg-gray-300"
                   }`}
                 ></span>
               );
             }
     
               return dotsToRender;
             } else {
               return Array.from({ length: totalSlides }).map((_, i) => (
               <span
                 key={i}
                 className={`h-2 w-2 rounded-full transition-all duration-300 ${
                   i === activeDot ? "bg-blue-600 scale-110" : "bg-gray-300"
                 }`}
               ></span>
               ));
             }
             })()}
             </div>
             )}

     
      <div className="flex justify-end mt-4">
        <button
          className="text-center px-3 py-1 text-xs md:text-sm xl:text-base text-[#A63F40] bg-[#f1c5c6] border border-[#913839] rounded-lg"
          onClick={() => navigate("/service")}
        >
          View More
        </button>
      </div>
    </div>
  );
}
